import { render, staticRenderFns } from "./restricciones-colaboraciones-seguimientos.vue?vue&type=template&id=310f57fb&"
import script from "./restricciones-colaboraciones-seguimientos.vue?vue&type=script&lang=js&"
export * from "./restricciones-colaboraciones-seguimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports